import { render, staticRenderFns } from "./RadioCheckbox.vue?vue&type=template&id=f64dfce6&scoped=true"
import script from "./RadioCheckbox.vue?vue&type=script&lang=js"
export * from "./RadioCheckbox.vue?vue&type=script&lang=js"
import style0 from "./RadioCheckbox.vue?vue&type=style&index=0&id=f64dfce6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f64dfce6",
  null
  
)

export default component.exports